import React, { useState, useCallback } from 'react';
import { 
  Dialog, 
  useMediaQuery, 
  useTheme, 
  IconButton, 
  DialogContent,
  AppBar,
  Toolbar,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ImageGallery from 'react-image-gallery';
import { GalleryContainer, MainImage, SmallImagesContainer, SmallImage } from './styled';
import 'react-image-gallery/styles/css/image-gallery.css';

const GalleryGrid = ({ images }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleImageClick = (index) => {
    setStartIndex(index);
    setShowDialog(true);
  };

  const handleClose = useCallback(() => {
    setShowDialog(false);
  }, []);

  // Handle keydown events for the Dialog
  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Escape') {
      handleClose();
    }
  }, [handleClose]);

  if (isMobile) {
    return (
      <>
        <ImageGallery
          items={images}
          showThumbnails={false}
          showPlayButton={false}
          showFullscreenButton={true}
          showNav={true}
          showBullets={true}
          additionalClass="mobile-gallery"
          renderItem={(item) => (
            <div
              style={{
                height: '250px',
                width: '100%',
                position: 'relative'
              }}
            >
              <img
                src={item.original}
                alt={item.description}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: theme.shape.borderRadius
                }}
                onClick={() => handleImageClick(images.indexOf(item))}
              />
            </div>
          )}
        />

        <Dialog
          open={showDialog}
          onClose={handleClose}
          fullScreen={fullScreen}
          maxWidth="lg"
          onKeyDown={handleKeyDown}
          PaperProps={{
            sx: {
              backgroundColor: 'background.paper',
              backgroundImage: 'none',
              height: fullScreen ? '100%' : '90vh',
              width: fullScreen ? '100%' : '90vw',
              m: fullScreen ? 0 : 2,
              overflowY: 'hidden'
            }
          }}
        >
          <AppBar position="relative" color="default" elevation={0}>
            <Toolbar>
              <Typography variant="h6" sx={{ flexGrow: 1 }}>
                Gallery
              </Typography>
              <IconButton
                edge="end"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent sx={{ p: 0, height: fullScreen ? 'calc(100% - 64px)' : '100%' }}>
            <ImageGallery
              items={images}
              startIndex={startIndex}
              showThumbnails={true}
              showPlayButton={false}
              showFullscreenButton={false}
              showNav={true}
              lazyLoad={true}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  }

  return (
    <>
      <GalleryContainer>
        <MainImage onClick={() => handleImageClick(0)}>
          <img src={images[0]?.original} alt={images[0]?.description} />
        </MainImage>
        <SmallImagesContainer>
          {images.slice(1, 5).map((image, index) => (
            <SmallImage key={index} onClick={() => handleImageClick(index + 1)}>
              <img src={image.original} alt={image.description} />
            </SmallImage>
          ))}
        </SmallImagesContainer>
      </GalleryContainer>

      <Dialog
        open={showDialog}
        onClose={handleClose}
        fullScreen={fullScreen}
        maxWidth="lg"
        onKeyDown={handleKeyDown}
        PaperProps={{
          sx: {
            backgroundColor: 'background.paper',
            backgroundImage: 'none',
            height: fullScreen ? '100%' : '90vh',
            width: fullScreen ? '100%' : '90vw',
            m: fullScreen ? 0 : 2,
            overflowY: 'hidden'
          }
        }}
      >
        <AppBar position="relative" color="default" elevation={0}>
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              Gallery
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: 0, height: fullScreen ? 'calc(100% - 64px)' : '100%' }}>
          <ImageGallery
            items={images}
            startIndex={startIndex}
            showThumbnails={true}
            showPlayButton={false}
            showFullscreenButton={false}
            showNav={true}
            lazyLoad={true}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GalleryGrid;